import Vue from "vue";
import VueRouter from "vue-router";
//import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/Public.vue"),
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("../views/Home.vue")
      },
      {
        path: "/about",
        name: "About",
        component: () => import("../views/About.vue")
      },
      {
        path: "/tours",
        name: "Tours",
        component: () => import("../views/Tours.vue")
      },
      {
        path: "/contact",
        name: "Contact",
        component: () => import("../views/Contact.vue")
      },
      {
        path: "/docs",
        name: "Documents",
        component: () => import("../views/Documents.vue")
      },
      {
        path: "/package",
        name: "Tour Detail",
        component: () => import("../views/Package.vue")
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
